import React from 'react';
import { getGeoInfo } from 'components/PageBuilder/PageBuilderFormPreview/domain';

const useGeoInfo = () => {

    const [geoInfo, setGeoInfo] = React.useState<any>({
        country_code: 'US',
    });

    React.useEffect(() => {
        getUserGeoInfo();
    }, []);

    const getUserGeoInfo = async () => {
        const geoInfo = await getGeoInfo();
        setGeoInfo(geoInfo);
    }

    return geoInfo;
}

export default useGeoInfo;